import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import useOrgChartState, { IOrgChart } from '@/states/organization.state';
import useTenantState from '@/states/tenant.state';
import { errorHandler } from '@/utils/functions/errorHandler';

export const useOrgChartInit = (organizationId?: number) => {
  const { currentTenant } = useTenantState();
  const { fetchOrgChartTree, createOrgChart } = useOrgChartState();

  const [treeData, setTreeData] = useState<IOrgChart | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    if (!currentTenant?.id) return;

    const initOrgChart = async () => {
      setIsLoading(true);
      try {
        const data = await fetchOrgChartTree(currentTenant.id, organizationId);

        if (data && (!Array.isArray(data) || data.length > 0)) {
          setTreeData(data);
          return;
        }

        // Only auto-create top role if we are viewing a specific organization (optional behavior?)
        // Or if we are viewing default structure.
        // If organizationId is provided, we should associate new Top Role with it.
        await createOrgChart({
          name: 'CEO',
          description: '',
          is_published: true,
          parent_id: null,
          organization_id: organizationId,
        });

        const newData = await fetchOrgChartTree(currentTenant.id, organizationId);
        if (newData) {
          setTreeData(newData);
          toast.info('Top Role node created automatically');
        }
      } catch (err) {
        errorHandler(err);
      } finally {
        setIsLoading(false);
      }
    };

    initOrgChart();
  }, [currentTenant?.id, organizationId]);

  return {
    treeData,
    isLoading,
    setTreeData,
  };
};
